import React from 'react'

export const About = () => {
    return (
        <div>
            this is an about MyComponents.
            <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Consequuntur explicabo architecto debitis similique quisquam eum! Id a quidem saepe reprehenderit enim fugit velit eius quasi quia, sint soluta fuga, sunt debitis eum vero dolorem!
            </p>
        </div>
    )
}

export default About
